import { gql } from "apollo-boost"

export default gql`
  subscription ChatMessageNotification {
    chatMessageNotification {
      chatMessage {
        id
        content
        sender {
          name
        }
        type
      }
      chatRoom {
        id
      }
    }
  }
`
